"use client";

import { useEffect } from "react";
import { isChunkLoadError, reloadOnceForChunk, reportClientError } from "@/lib/mobile/report-error";

// Граница ошибок маршрута (Next App Router, заход 07.09). Ловит всё, что не
// поймали локальные границы: вместо белого экрана — понятный текст и две
// кнопки. Ошибка уходит оператору.
export default function RouteError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    const msg = error.message || String(error);
    if (isChunkLoadError(msg)) {
      reportClientError("chunk", msg, error.stack, { digest: error.digest });
      reloadOnceForChunk();
      return;
    }
    reportClientError("render", msg, error.stack, { digest: error.digest, boundary: "route" });
  }, [error]);

  return (
    <main style={{ minHeight: "100dvh", display: "grid", placeItems: "center", padding: 24, fontFamily: "system-ui, -apple-system, sans-serif" }}>
      <div style={{ maxWidth: 420, textAlign: "center" }}>
        <div style={{ fontSize: 22, fontWeight: 700 }}>Экран не открылся</div>
        <p style={{ opacity: 0.7, marginTop: 8, lineHeight: 1.45 }}>
          Мы уже получили отчёт об ошибке. Попробуйте ещё раз — обычно помогает.
        </p>
        <div style={{ display: "flex", gap: 10, justifyContent: "center", marginTop: 18, flexWrap: "wrap" }}>
          <button
            type="button"
            onClick={reset}
            style={{ padding: "10px 18px", borderRadius: 999, border: "none", background: "#111", color: "#fff", fontSize: 15, cursor: "pointer" }}
          >
            Попробовать снова
          </button>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{ padding: "10px 18px", borderRadius: 999, border: "1px solid rgba(0,0,0,0.2)", background: "transparent", fontSize: 15, cursor: "pointer" }}
          >
            Перезагрузить
          </button>
        </div>
        {process.env.NODE_ENV !== "production" && (
          <pre style={{ textAlign: "left", marginTop: 20, fontSize: 12, whiteSpace: "pre-wrap", opacity: 0.8 }}>{error.message}</pre>
        )}
      </div>
    </main>
  );
}
